/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import fetchAPI from './../helper/axios';
import Load from './load';
import fetchAPICustom from '../helper/custom';
import { ImagePath } from '../helper/constants';

const PrivacyPolicy: React.FC = () => {
     // tab data
     const [policyData, setData] = useState<any>();  

   
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

useEffect(() => {
    const loadData = async () => {
      try {
        setData(await fetchAPI('node/58'));
        
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

    const policyurl = policyData?.field_link_url?.[0].uri.replace("internal:", "");
  if (loading) return <Load />;
  // if (error) return <div>Error: {error}</div>;

  return (
 <>
   
  <main className="main">
   
    <section id="about" className="about privacy section mt-5">
        <div className="container mt-5" data-aos="fade-up" data-aos-delay="100">
            <div className="row gx-2 align-items-xl-center text-center gy-md-5">
                <div className="col-xl-12 content content1 mt-4 pb-4">
                    <h2 className="title">
                        {policyData?.title?.[0]?.value}                               
                    </h2>
                </div>
               
            </div>
       
            <div className="row gx-2 align-items-xl-center  mt-4">
                <div className="col-xl-12 content ">
                    <div className="row gy-4 icon-boxes">
                          {policyData?.field_privacy_policy_description?.length > 0 ? (
                            policyData?.field_privacy_policy_description?.map((item:any, index:any) => (
                            <div className=" col-md-12" key={index} data-aos="fade-up" data-aos-delay="100">
                            
                                <div  dangerouslySetInnerHTML={{ __html:item.value }}>

                                </div>
                                
                            </div>
                         ))) : (
                                <div className="col-md-12">No Data found.</div>
                        )}
                        <div className=" col-md-12" data-aos="fade-up" data-aos-delay="100">
                            
                                <p>
                                 {policyData?.field_policy_short_description?.[0].value } <a href={policyurl } title={policyurl }>{policyData?.field_link_url?.[0].title }</a>
                                </p>
                                
                            </div>
                             <div className=" col-md-12" data-aos="fade-up" data-aos-delay="100">
                            
                                <p className="termline"> {policyData?.field_term_accept_line?.[0].value }  </p>
                                
                            </div>
                    </div>
                  
                </div>

            </div>
        </div>

    </section>{/* /About Section */}
 
</main>
</>
  );
};

export default PrivacyPolicy;